module.exports = __webpack_public_path__ + "static/media/plane(20).b816e8f6.PNG";